export const name = 're-shop-product-item-custom'

import props from './props'
import mixins from '../base/custom/mixin'
export {props, mixins}

export const EventBus = window.VueEventBus

// data
const propDefs = props
export const data = {
  propDefs,
}

export default {
  name,
  mixins,
  props,
  data,
  EventBus,
}
